import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column'
import Layout from '../components/Layout'
import {fetchassesmentOpinion} from '../redux/features/assestmentOpinion.feature';
import {BASE_URL} from '../utils/commonUrl';
import {Button} from 'primereact/button';
import axios from 'axios';
import AssessmentOpinionForm from './forms/AssessmentOpinionForm';
import {Toast} from 'primereact/toast';
import {Dialog} from 'primereact/dialog';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const AssessmentOpinion = () => {
    const dispatch = useDispatch();
    const {assesmentOpinion} = useSelector((state) => {
        return state["assestmentOpinion"]
    })

    const primeToast = useRef(null)

    const [save, setSave] = useState({loading: false, success: true, message: ''});
    const [assessmentOpinionItem, setAssessmentOpinionItem] = useState({
        title: '',
        titleBangla: "",
        weight: 0,
        active: true,
        assestmentOpinionID: 0
    })
    const [modal, setModal] = useState(false)
    const [start, setFirst] = useState(0);

    useEffect(() => {
        initFilters1();
        dispatch(fetchassesmentOpinion())
        console.log(assesmentOpinion)
    }, [])

    const onSubmit = async data => {
        saveAssessmentOpinion(data)
    }

    const saveAssessmentOpinion = async data => {
        try {
            setSave(prev => ({...prev, loading: true}))
            const url = BASE_URL + "/api/assesmentOpinion";
            const response = await axios.post(url, data);
            setSave(prev => ({...prev, success: true, loading: false}))

            if (response.status === 200) {
                primeToast.current.show({
                    severity: 'success',
                    summary: 'success',
                    detail: 'Quarter Save successfully',
                    life: 3000
                });
                setAssessmentOpinionItem({
                    title: '',
                    titleBangla: "",
                    weight: 0,
                    active: true,
                    assestmentOpinionID: 0
                });
                setModal(!modal)
                dispatch(fetchassesmentOpinion())
            }
        } catch (e) {
            console.log(e)
            setSave(prev => ({...prev, success: false, loading: false, message: e.message}))
            primeToast.current.show({severity: 'error', summary: 'error', detail: 'An Error ', life: 3000});
        }
    }


    const onHide = () => {
        setModal(!modal)
        setAssessmentOpinionItem({
            title: '',
            titleBangla: "",
            weight: 0,
            active: true,
            assestmentOpinionID: 0
        });
    }

    const editGridData = data => {
        setAssessmentOpinionItem({
            title: data.title,
            titleBangla: data.titleBangla,
            weight: data.weight,
            active: data.active,
            assestmentOpinionID: data.assestmentOpinionID
        });
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteassestmentTitleIndicatorItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }


    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }


    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'title': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'titleBangla': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },

            'weight': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end


    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editGridData(rowData)}/>
                &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                                 onClick={() => deleteGridData(rowData)}/>
            </>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1}
                               placeholder="Keyword Search"/>
                </span>
                </div>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Assessment
                    Opinion
                </button>
            </div>
        </div>
    );

    // const footer =`In total there are ${state.assesmentOpinion ? state.assesmentOpinion.length : 0} assestmentTitleIndicator.`;

    const _isActiveColumn = (rowData) => {
        return <div>{rowData.active ? <>Active</> : <>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={assesmentOpinion} header={header} paginator rows={7} first={start}

                   showGridlines
                   dataKey="assestmentOpinionID" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['title', 'titleBangla', 'weight', 'active']}

                   paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="assestmentOpinionID" header="assestmentOpinionID" hidden={true}/>
            <Column field='title' header="Title"/>
            <Column field='titleBangla' header="Title Bangla"/>
            <Column field='weight' header="weight" hidden={false}/>
            <Column field='active' header="Active" body={_isActiveColumn}/>
            <Column body={actionBodyTemplate} header="Action" exportable={false}
                    style={{minWidth: '4rem', textAlign: "center"}}/>
        </DataTable>
    )


    return <>
        <Layout>
            <Toast ref={primeToast}/>
            <AssessmentOpinionForm
                onSubmit={onSubmit}
                onHide={onHide}
                modal={modal}
                title={assessmentOpinionItem.title}
                active={true}
                isLoading={false}
                assestmentOpinionID={assessmentOpinionItem.assestmentOpinionID}
                titleBangla={assessmentOpinionItem.titleBangla}/>
            {Table}
        </Layout>
    </>

}
export default AssessmentOpinion